import '../chart_view.js.coffee'
class Monitoring.Views.Charts.CountBarsChartView extends Monitoring.Views.Charts.ChartView

  template: JST['backbone/templates/monitoring/charts/empty_chart']

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (container = {}) =>
    @$el.html(@template())
    @benchmarkChart = new Highcharts.Chart(@chartOptions(container))
    @trigger('masonry')

  chartOptions:(data, title) ->
    options = {
      chart:
        type: 'column'
        backgroundColor: '#f2f2f2'
        renderTo: @$el.find('#container')[0]
        width: 800
      title:
        text: title
      xAxis:
        type: 'category'
        labels:
          rotation: 0
          style:
            fontSize: '13px'
            fontFamily: 'Roboto, elvetica Neue, Helvetica, Arial, sans-serif'
      legend:
        enabled: false
      tooltip:
        followPointer: true
        positioner: (labelWidth, labelHeight, point) ->
          chart = this.chart
          pointX = if (point.plotX + labelWidth > chart.plotWidth) then point.plotX + chart.plotLeft - labelWidth - 10 else point.plotX + chart.plotLeft + 10
          x = if pointX > 0 then pointX else 0
          y = if point.plotY + chart.plotTop - 20 > 35 then point.plotY + chart.plotTop - 20 else 35
          return { x: x , y: y }
      series:[{
        name: 'Count'
        data: data
        dataLabels:
          enabled: true
          style:
            fontSize: '13px'
            fontFamily: 'Roboto, elvetica Neue, Helvetica, Arial, sans-serif'
      }]
    }
